// eslint-disable-next-line @typescript-eslint/naming-convention
export const InviteUserConfig = {
	messages: {
		partialSuccess: 'Your bulk invite is partially successful',
		completeSuccess: 'Invite sent successfully.',
		failure: 'Invites could not be sent for review.',
		downloadReport: 'Download Report',
		partialSuccessDescription: (successCount: number, res: number, failedCount: number) => 
			`${successCount} out of ${res} invites have been invited, while ${failedCount} entries had issues. Please review and re-upload the updated file.`,
		completeSuccessDescription: (res: number) => 
			`${res} out of ${res} invites have been sent for review. Please download the report for details.`,
		completeSuccessDescriptionTMHCorp: (res: number) => 
			`${res} out of ${res} invites have been invited as per provided. Please download the report for details.`,
		failureDescription: 'Invites were not sent due to some errors. Please review and re-upload the updated file.',
		toasterSuccessMsg: 'Bulk user invite sent successfully.',
		toasterPartialMsg: 'Some invitations failed',
		toasterFailMsg: 'User Invite failed',
		TMHCorpFailure: 'Your bulk user invite has failed',
		TMHCorpNote: 'Invites failed due to some errors. Please review and re-upload the updated file.'

	}
};
